//------------------------------------------------------------------------
// Automatically add an icon to external links
//
// FIXME: Demo script, don’t include in production unless actually needed
//------------------------------------------------------------------------
// Import the ES5 code since Webpack isn’t setup to transpile external resources
import Unorphanize from "@threespot/unorphanize";

const externalIcon =
  '<svg width="14" height="14" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.962 1H1v17h17v-6.962h-1.943v5.02H3.105V3.104h4.857V1zM18 1h-7.448v2.105h3.961l-8.637 8.637 1.33 1.596 8.851-8.851v3.96H18V1z" fill="#070606"/><path d="M1 1V.5H.5V1H1zm6.962 0h.5V.5h-.5V1zM1 18H.5v.5H1V18zm17 0v.5h.5V18H18zm0-6.962h.5v-.5H18v.5zm-1.943 0v-.5h-.5v.5h.5zm0 5.02v.5h.5v-.5h-.5zm-12.952 0h-.5v.5h.5v-.5zm0-12.953v-.5h-.5v.5h.5zm4.857 0v.5h.5v-.5h-.5zM10.552 1V.5h-.5V1h.5zM18 1h.5V.5H18V1zm-7.448 2.105h-.5v.5h.5v-.5zm3.961 0l.354.353.853-.853h-1.207v.5zm-8.637 8.637l-.353-.354-.323.323.292.35.384-.32zm1.33 1.596l-.384.32.35.42.388-.387-.354-.353zm8.851-8.851h.5V3.28l-.853.853.353.354zm0 3.96h-.5v.5h.5v-.5zm1.943 0v.5h.5v-.5H18zM1 1.5h6.962v-1H1v1zM1.5 18V1h-1v17h1zm16.5-.5H1v1h17v-1zm-.5-6.462V18h1v-6.962h-1zm-1.443.5H18v-1h-1.943v1zm.5 4.52v-5.02h-1v5.02h1zm-13.452.5h12.952v-1H3.105v1zm-.5-13.453v12.952h1V3.105h-1zm5.357-.5H3.105v1h4.857v-1zM7.462 1v2.105h1V1h-1zm3.09.5H18v-1h-7.448v1zm.5 1.605V1h-1v2.105h1zm3.461-.5h-3.96v1h3.96v-1zm-8.283 9.49l8.637-8.637-.707-.707-8.637 8.637.707.707zm1.36.923l-1.33-1.596-.768.64 1.33 1.596.768-.64zm8.114-8.885l-8.851 8.851.707.707 8.85-8.85-.706-.708zm.853 4.315V4.487h-1v3.96h1zm1.443-.5h-1.943v1H18v-1zM17.5 1v7.448h1V1h-1z" /></svg>';

// Find all non-relative links
var links = document.querySelectorAll('.u-richtext a[href^="http"]');

// Filter out buttons and links inside of divs (i.e. shortcodes)
if (links.length) {
  links = Array.prototype.slice.call(links).filter((el) => {
    var isInsideDiv = el.parentNode.tagName.toLowerCase() === "div" || false;
    var isButton = el.classList.contains("Button");
    return !isInsideDiv && !isButton;
  });
}

links.forEach(function (el) {
  // Create a dummy anchor element to easily get the hostname of the href attribute
  // https://gist.github.com/jlong/2428561
  var a = document.createElement("a");
  a.href = el.href;

  // Compare the link hostname to the window hostname
  if (a.hostname !== window.location.hostname) {
    new Unorphanize(el, {
      inlineStyles: false,
      className: "u-nowrap is-external",
      append: externalIcon,
    });
  }
});



// WEBPACK FOOTER //
// ./scripts/modules/external-links.js